import axios from "@/axios";
import { Price } from "@/features/pricing/components/IAIPrice/IAIPrice.vue";
import type { Ref } from "vue";
export type FilterOption = {
  value: string;
  label: string;
};

type CompareStyleImageKey = string;
type CompareStyleImageSrc = string;
export type CompareStyleImages = Record<CompareStyleImageKey, CompareStyleImageSrc>;

export type IProfileShopFiltersResponse = {
  type: FilterOption[];
  style: FilterOption[];
  format: FilterOption[];
  genres: FilterOption[];
  quick_filters: string[];
  sort: FilterOption[];
  price: {
    min: Price;
    max: Price;
  };
  original_preview_images: CompareStyleImages;
};

export interface IProfileShopError {
  detail: string;
}

export async function getProfileShopFilters() {
  const res = await axios.get<IProfileShopFiltersResponse>("web_account/profile_shop/filters");
  return res;
}

export interface ProfileGridObject {
  bundle_id: string;
  slug: string;
  cover_image: string;
  seller_image: string;
  profile_name: string;
  seller_name: string;
  tags: string[];
  format: string;
  discount?: {
    discount_price: Price;
    discount_percentage: number;
  };
  price: Price;
  edited_preview_images: CompareStyleImages;
}

export interface IProfileShopProfilesResponse {
  profiles: ProfileGridObject[];
  total_count: number;
  page_count: number;
}

export interface IProfileShopProfilesRequest {
  page: number;
  page_size: number;
  filters?: {
    type?: string[];
    style?: string[];
    format?: string[];
    genres?: string[];
    sort?: string;
    price?: {
      min: Price;
      max: Price;
    };
  };
}

export async function getProfileShopProfiles(params: IProfileShopProfilesRequest) {
  const res = await axios.post<IProfileShopProfilesResponse>("web_account/profile_shop/profiles", params);
  return res.data;
}

export const profileShopQueryOptions = (params: Ref<IProfileShopProfilesRequest>) => ({
  queryKey: ["profile-shop"],
  queryFn: () => getProfileShopProfiles(params.value),
});

export interface ProfileShopBanner {
  image_url: {
    mobile: string;
    desktop: string;
  };
  campaign_name: string;
  link_url?: string;
}

export interface IProfileShopBannersResponse {
  banners: ProfileShopBanner[];
}

export async function getProfileShopBanners() {
  const res = await axios.get<IProfileShopBannersResponse>("web_account/profile_shop/banners");
  return res.data;
}

export const profileShopBannersQueryOptions = () => ({
  queryKey: ["profile-shop-banners"],
  queryFn: () => getProfileShopBanners(),
});

export type BundleRecommendationRequest = {
  type: "bundle";
  bundle_id: string;
};

export type FilterRecommendationRequest = {
  type: "filters";
  filters: IProfileShopProfilesRequest["filters"];
};

export type ProfileRecommendationsRequest = BundleRecommendationRequest | FilterRecommendationRequest;

export interface IProfileRecommendationsResponse {
  profiles: ProfileGridObject[];
}

export async function getProfileRecommendations(params: ProfileRecommendationsRequest) {
  const res = await axios.post<IProfileRecommendationsResponse>(
    "web_account/profile_shop/profile_recommendations",
    params
  );
  return res.data;
}

export const profileRecommendationsQueryOptions = (params: Ref<ProfileRecommendationsRequest>) => ({
  queryKey: ["profile-recommendations", params.value],
  queryFn: () => getProfileRecommendations(params.value),
  staleTime: 5 * 60 * 1000, // 5 minutes
  cacheTime: 10 * 60 * 1000, // 10 minutes
});
